import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Box, Card, CardBody, CardHeader, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import { motion } from "framer-motion";

import { selectActiveProperties } from "../../redux/user/userSlice";

import PersonalInformation from "./PersonalInformation";

const MotionBox = motion(Box);

export default function Tenant() {
	const { propertyId, tenantId } = useParams();
	const properties = useSelector(selectActiveProperties);
	const tenant =
		properties?.find((p) => p.id === propertyId).tenants.find((t) => t.id === tenantId) ||
		properties?.find((p) => p.id === propertyId).formerTenants.find((t) => t.id === tenantId);
	console.log(tenant);
	const tabs = [{ title: "Personal Information", component: <PersonalInformation tenant={tenant} propertyId={propertyId} /> }];

	const bgColor = useColorModeValue("white", "gray.800");
	const borderColor = useColorModeValue("gray.200", "gray.700");
	const tabBg = useColorModeValue("gray.50", "gray.700");
	const activeTabBg = useColorModeValue("white", "gray.800");

	useEffect(() => {
		console.log("tenant: ", tenant);
	}, [tenant]);

	return (
		<MotionBox initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
			<Card boxShadow="sm" borderRadius="lg" bg={bgColor} borderWidth="1px" borderColor={borderColor}>
				<CardHeader fontSize="2xl" fontWeight="bold" pb={6} borderBottomWidth="1px" borderColor={borderColor}>
					Tenant Details
				</CardHeader>
				<CardBody pt={6}>
					<Tabs variant="enclosed" isFitted isLazy colorScheme="blue">
						<TabList overflowX="auto" overflowY="hidden" borderBottomWidth="2px" borderColor={borderColor} mb={4}>
							{tabs.map((t, index) => (
								<Tab
									key={index}
									_selected={{
										bg: activeTabBg,
										borderColor: borderColor,
										borderBottomColor: activeTabBg,
										mb: "-2px",
										fontWeight: "semibold",
									}}
									py={3}
									bg={tabBg}
									borderRadius="md"
									borderTopRadius="md"
									mx={1}
									transition="all 0.2s"
									_hover={{ bg: activeTabBg }}
								>
									{t.title}
								</Tab>
							))}
						</TabList>
						<TabPanels>
							{tabs.map((t, index) => (
								<TabPanel key={index} px={0}>
									{/* <Card variant="outline" borderRadius="lg" borderColor={borderColor} transition="all 0.2s" _hover={{ boxShadow: "sm" }}>
										<CardHeader fontWeight="bold" fontSize="xl" pb={4} borderBottomWidth="1px" borderColor={borderColor}>
											{t.title}
										</CardHeader>
										<CardBody pt={6}>{t.component}</CardBody>
									</Card> */}
									{t.component}
								</TabPanel>
							))}
						</TabPanels>
					</Tabs>
				</CardBody>
			</Card>
		</MotionBox>
	);
}
